import { Component, OnInit } from '@angular/core';
import { ConfirmationModalOptions } from 'src/app/shared/models/modal.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalService } from 'src/app/shared/global.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { AlertService } from 'src/app/shared/services/alert.service';
import { Router } from '@angular/router';
import { UtilService } from 'src/app/shared/services/util.service';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import * as moment from 'moment';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ReprogramarTurnoComponent } from '../reprogramar-turno/reprogramar-turno.component';

@Component({
  selector: 'app-cancelar-agenda-virtual',
  templateUrl: './cancelar-agenda-virtual.component.html',
  styleUrls: ['./cancelar-agenda-virtual.component.scss']
})

export class CancelarAgendaVirtualComponent implements OnInit {

  public filtroNumeroDocumento: string;
  public filtroTipoDocumento: string;
  public filtroNombre: string;
  public filtroCorreoElectronico: string;
  public filtroGenero: string;
  public filtroTelefono: string;

  public tipoDocumento: string;
  public numeroDocumento: string;
  public agendasVirtuales: string[];
  public paginas: number[];
  public inicio: number;
  public fin: number;
  public modalOptionsReprogramarTurno: ConfirmationModalOptions;
  public modalOptionsCancelarAgendaVirtual: ConfirmationModalOptions;
  public rangoCancelacion: any;
  public fechaActual: string;
  public fechaTurno: string;

  constructor(
    private router: Router,
    private global: GlobalService,
    private urlService: UrlService,
    private spinner: NgxSpinnerService,
    private alertService: AlertService,
    private utilService: UtilService,
    private modalService: NgbModal
  ) {
    this.tipoDocumento = sessionStorage.getItem(ConstantesService.TIPO_DOC_SESSSION);
    this.numeroDocumento = sessionStorage.getItem(ConstantesService.NUM_DOC_SESSSION);
  }
  ngOnInit() {
    if (this.tipoDocumento && this.numeroDocumento) {
      this.consultarPersona();
      this.obtenerParametroRangoCancelacion();
    } else {
      this.router.navigate(['/agenda-virtual']);
    }
    this.paginas = [];
    this.modalOptionsReprogramarTurno = new ConfirmationModalOptions(
      'Confirmación',
      ConstantesService.MSJ_CONF_REPROGRAMAR_AGENDA_VITUAL,
      'SI', 'NO', 'fa fa-calendar-alt', false, false, 'Reprogramar', null, 'btn-secondary');
    this.modalOptionsCancelarAgendaVirtual = new ConfirmationModalOptions(
      'Confirmación',
      ConstantesService.MSJ_CONF_CANCELAR_AGENDA_VITUAL,
      'SI', 'NO', 'fa fa-times-circle', false, false, 'Cancelar', null, 'btn-secondary');
  }

  /**
   * Metodo que consulta la información de la persona
   */
  public consultarPersona() {
    const serviceProvider = 'ObtenerVisitante';
    const pathParams: Array<[string, string]> = new Array<[string, string]>();
    pathParams.push(['filterBy=visitantePK.numDocVisitante', this.numeroDocumento]);
    pathParams.push(['visitantePK.tipoDocVisitante', this.tipoDocumento]);
    const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, pathParams, null), this.urlService.hostAPI_UAC);
    this.global.getPublico(url).subscribe(
      data => {
        const infoPersona = data;
        if (infoPersona.length > 0) {
          this.filtroNumeroDocumento = infoPersona[0].visitantePK.numDocVisitante;
          this.filtroCorreoElectronico = infoPersona[0].correoVisitante;
          this.filtroNombre = infoPersona[0].nombreCompleto;
          this.filtroTelefono = infoPersona[0].telefono;
          this.obtenerDominioTipoDocumento(infoPersona[0].visitantePK.tipoDocVisitante);
          this.obtenerGenero(infoPersona[0].genero);
          this.consultarAgendaVirtual();
        }
      }, err => {
        this.spinner.hide();
        this.cathException('No se pudo consultar la persona');
      });
  }


  /**
   * Consulta el dominio del tipo de documento
   */
  public obtenerDominioTipoDocumento(tipoDocumento: any) {
    this.spinner.show();
    const serviceProvider = 'ObtenerDominio';
    const pathParams: Array<[string, string]> = new Array<[string, string]>();
    pathParams.push(['filterBy=detalleDominioPK.nombreDominio', 'TipoIdentificacion']);
    pathParams.push(['detalleDominioPK.nombreDetalleDominio', tipoDocumento]);
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, pathParams, null), this.urlService.hostAPI_TRANS);
    this.global.getPublico(url).subscribe(
      data => {
        this.filtroTipoDocumento = data[0].valor;
        this.spinner.hide();
      }, err => {
        this.cathException('No es posible Obtener el tipo de Documento');
      }
    );
  }

  /**
   * Consulta el dominio del genero
   */
  public obtenerGenero(genero: any) {
    this.spinner.show();
    const serviceProvider = 'ObtenerDominio';
    const pathParams: Array<[string, string]> = new Array<[string, string]>();
    pathParams.push(['filterBy=detalleDominioPK.nombreDominio', 'Genero']);
    pathParams.push(['detalleDominioPK.nombreDetalleDominio', genero]);
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, pathParams, null), this.urlService.hostAPI_TRANS);
    this.global.getPublico(url).subscribe(
      data => {
        this.filtroGenero = data[0].valor;
        this.spinner.hide();
      }, err => {
        this.cathException('No es posible Obtener el genero');
      }
    );
  }

  /**
   * Metodo que consulta las agendas virtuales repecto a la persona ingresada
   */
  public consultarAgendaVirtual() {
    this.spinner.show();
    const serviceProvider = 'obtenerPersonaAgendasVirtuales';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    queryParams.push(['numeroDocumento', this.numeroDocumento]);
    queryParams.push(['tipoDocumento', this.tipoDocumento]);
    const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_UAC);
    this.global.postPublico(url).subscribe(
      data => {
        this.agendasVirtuales = data;
        this.paginador();
        this.spinner.hide();
      }, err => {
        this.spinner.hide();
        this.cathException('No se pudo consultar agendadas virtuales');
      });
  }

  /**
   * Metodo que evalua el paginador par ubicar en bloques de 10 registros
   */
  public paginador() {
    this.paginas = [];
    this.inicio = 0;
    this.fin = 10;
    if (this.agendasVirtuales) {
      const paginaAdicional: boolean = (this.agendasVirtuales.length % 10) !== 0;
      let numeroPaginas = Math.round(this.agendasVirtuales.length / 10);
      numeroPaginas = paginaAdicional ? numeroPaginas + 1 : numeroPaginas;

      for (let i = 0; i < numeroPaginas; i++) {
        const element = numeroPaginas[i];
        this.paginas.push(element);
      }
    }
  }

  /**
   * Metodo que realiza el cambio de pagina
   * @param  valor valor anterior o siguiente
   */
  public cambiarPagina(valor: any) {
    switch (valor) {
      case 'a':
        this.inicio = 0;
        this.fin = 10;
        break;

      case 's':
        const mod = this.agendasVirtuales.length % 10;

        if (mod === 0) {
          this.inicio = this.agendasVirtuales.length - 10;
        } else {
          this.inicio = this.agendasVirtuales.length - mod;
        }
        this.fin = this.agendasVirtuales.length;
        break;

      default:
        this.inicio = (valor - 1) * 10;
        this.fin = valor * 10;
        break;

    }
  }

  /**
   * Metodo que actualiza la informacion de la persona ya sea que se alla modificado el
   * correo electronico o el telefono
   */
  public actualizarInformacionPersona() {
    this.spinner.show();
    const serviceProvider = 'actualizarInfoVisitante';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    queryParams.push(['tipoDocumento', this.tipoDocumento]);
    queryParams.push(['numeroDocumento', this.numeroDocumento]);
    queryParams.push(['correoElectronico', this.filtroCorreoElectronico]);
    queryParams.push(['telefono', this.filtroTelefono]);
    const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_UAC);
    this.global.postPublico(url).subscribe(
      data => {
        this.alertService.generateAlertSuccess('La información ha sido actualizada', '');
        this.spinner.hide();
      }, err => {
        this.spinner.hide();
        this.cathException('No se pudo actualizar la informacion de la persona');
      });
  }

  /**
   * Metodo que cancela el turno seleccionado
   * @param agenda contiene el registro seleccionado para cancelar el registro
   */
  public getConfirmationCancelarAgendaVirtual(agenda) {
    const serviceProvider = 'cancelarAgendaVirtual';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    queryParams.push(['idAgendaVirtual', agenda.idAgendaVirtual]);
    queryParams.push(['correo', this.filtroCorreoElectronico]);
    queryParams.push(['tramite', agenda.tramite]);
    queryParams.push(['sede', agenda.sede]);
    queryParams.push(['tipoDiscapacidad', agenda.tipoDiscapacidad]);
    const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_UAC);
    this.global.postPublico(url).subscribe(
      data => {
        this.alertService.generateAlertSuccess('Se canceló el turno virtual exitosamente', '');
        this.consultarAgendaVirtual();
        this.spinner.hide();
      }, err => {
        this.spinner.hide();
        if (err.status === 500) {
          this.cathException(err.error.message);
        } else {
          this.cathException('No se pudo cancelar el turno virtual');
        }
      });
  }

  /**
   * Metodo que valida al cancelar la agenda tiene 2 horas de anticipacion como minimo
   * @param event constiene el valor true o false del modal de confirmacion
   * @param agenda contiene el registro seleccionado para cancelar el registro
   */
  public validarFechas(event, agenda, accion) {
    if (event[0]) {
      const textoAccion = accion ? 'cancelar' : 'reprogramar';
      this.spinner.show();
      if (agenda.estado !== DominiosService.VALOR_DOMINIO_INGRESADO) {
        const rango = this.rangoCancelacion[0].valor.split(':');
        if (this.validarTiempoLimite(agenda, rango)) {
          if (accion) {
            this.getConfirmationCancelarAgendaVirtual(agenda);
          } else {
            this.getConfirmationReprogramarTurno(agenda);
          }
        } else {
          this.cathException(`Apreciado(a) ciudadano(a) le informamos que el tiempo máximo para ${textoAccion}`
            + ` un turno virtual es de ${this.rangoCancelacion[0].valor} horas, lo invitamos a programar `
            + `un nuevo turno virtual`);
        }
      } else {
        this.cathException(`El turno seleccionado no se puede ${textoAccion} por que ya tiene registro de ingreso a la UAC`);
      }
    }
  }

  /*
   * Metodo que reprograma el turno seleccionado
   * @param event contiene el registro seleccionado para cancelar el registro
   */
  public getConfirmationReprogramarTurno(agenda) {
    const modalRef = this.modalService.open(ReprogramarTurnoComponent, { centered: true, size: 'lg' });
    modalRef.componentInstance.agendaData = agenda;

    modalRef.result.then((result) => {
      if (result && result.idAgendaVirtual) {
        this.consultarAgendaVirtual();
      }
    }, (reason) => {
      if (reason === ModalDismissReasons.ESC ||
        reason === ModalDismissReasons.BACKDROP_CLICK) { }
    });
  }

  public validarTiempoLimite(agenda, rango) {
    let valido = false;
    if (rango.length === 2 && !isNaN(Number(rango[0])) && !isNaN(Number(rango[1]))) {
      let fechaActual = moment(new Date()).add('hours', Number(rango[0]));
      fechaActual = fechaActual.add('minutes', Number(rango[1]));
      valido = fechaActual.isBefore(agenda.fechaInicio);
    }

    return valido;
  }

  /*
   * Metodo que obtiene el parametro con el nombre RANGO_CANCELAR_AGENDA
   */
  public obtenerParametroRangoCancelacion() {
    this.spinner.show();
    const serviceProvider = 'ObtenerParametros';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    queryParams.push(['filterBy=nombre', 'RANGO_CANCELAR_AGENDA']);
    const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_TRANS);
    this.global.getPublico(url).subscribe(
      data => {
        this.rangoCancelacion = data;
        const hoy = new Date();
        this.fechaActual = this.utilService.convertirDate(hoy);
        this.spinner.hide();
      }, err => {
        this.cathException('Error Consultando el Rango de Cancelacion');
      }
    );
  }

  /*
   * Método de control de Excepciones
   * @param error  mensaje saliente respecto al error ocurrido
   */

  cathException(error) {
    this.alertService.generateAlertError(error, 'Error');
    this.spinner.hide();
  }


  regresarConsulta() {
    sessionStorage.removeItem(ConstantesService.NUM_DOC_SESSSION);
    sessionStorage.removeItem(ConstantesService.TIPO_DOC_SESSSION);
    this.router.navigate(['agenda-virtual']);
  }

  redireccionSolicitud() {
    this.router.navigate(['agenda-virtual/solicitar-agenda-virtual']);
  }
}
